export interface Company {
  id: string;
  name: string;
  status: Status;
  subscriptionPlan: SubscriptionPlanName | null;
  numberOfProjects: string;
  companyType: string;
  companyAvatar: string;
  activationDate: null | Date;
}

export interface BasicInfo {
  id: number;
  companyName: Company['name'];
  companyType: {
    id: number;
    type: null | string;
  };
  taxID: string;
  companySize: {
    id: number;
    size: null | string;
  };
  companyStatus: {
    id: number;
    status: Company['status'];
  };
  numberOfProjects: Company['numberOfProjects'];
  countryList: {
    name: string;
  }[];
  companyLogoFileName: string;
  companyLogoFilePath: string;
  companyLogoSize: string;
  companyLogoThumbnailFileName: string;
  companyLogoThumbnailFilePath: string;
  companyLogoThumbnailSize: string;
  commercialRecordDocumentFileName: string;
  commercialRecordDocumentFilePath: string;
  commercialRecordDocumentSize: string;
  taxCardDocumentFileName: string;
  taxCardDocumentFilePath: string;
  taxCardDocumentSize: string;
  isDeleted: boolean;
  createdAt: Date;
  modifiedAt: Date;
  activationDate: Company['activationDate'];
}

export enum Status {
  'Active' = 'Active',
  'Inactive' = 'Inactive',
  'Pending' = 'Pending',
}

export enum SubscriptionPlanName {
  'Starter' = 'Starter',
  'Golden' = 'Golden',
  'Platinum' = 'Platinum',
}

export interface ContactInfo {
  id: number;
  companyBasicInfo: BasicInfo;
  countryCode: string;
  phoneNumber: string;
  firstName: string;
  lastName: string;
  email: string;
  jobTitle: string;
}

export interface TeamMember {
  id: number;
  companyBasicInfo: BasicInfo;
  firstName: string;
  lastName: string;
  countryCode: string;
  phoneNumber: string;
  email: string;
  status: Status;
}

export interface SubscriptionPlan {
  id: number;
  companyBasicInfo: BasicInfo;
  subscriptionPlan: {
    id: number;
    planName: Company['subscriptionPlan'];
  };
}

export interface ChangedStatus {
  page: null;
  size: null;
  criteriaFilter: null;
  companyId: number;
  statusId: number;
}

export interface PaginatedCompany {
  page: number;
  status?: string;
  name?: string;
  subscriptionPlan?: string;
}

export interface Role {
  id: number;
  name: string;
  description: string;
  status: Status;
  permission: Permission[];
  companyBasicInfo: BasicInfo;
  reportTo?: Role;
}

export interface Permission {
  id: number;
  permissionName: string;
  permissionActions: { id: number; action: Action; enabled: boolean }[];
}

export interface Action {
  id: number;
  description: string;
  operationId: string;
}
